import { createContext, useContext, useCallback, useState } from "react";

const RefreshContext = createContext({
  onSessionRefresh: () => {},
  onSlotRefresh: () => {},
  onCalendarRefresh: () => {},
  setOnSessionRefresh: () => {},
  setOnSlotRefresh: () => {},
  setOnCalendarRefresh: () => {},
});

export const RefreshProvider = ({ children }) => {
  const [onSessionRefresh, setOnSessionRefresh] = useState(null);
  const [onSlotRefresh, setOnSlotRefresh] = useState(null);
  const [onCalendarRefresh, setOnCalendarRefresh] = useState(null);

  const handleSessionRefresh = useCallback(() => {
    if (onSessionRefresh) {
      onSessionRefresh();
    } else {
      console.warn("No refresh function registered!");
    }
  }, [onSessionRefresh]);

  const handleSlotRefresh = useCallback(() => {
    if (onSlotRefresh) {
      onSlotRefresh();
    } else {
      console.warn("No refresh function registered!");
    }
  }, [onSlotRefresh]);

  const handleCalendarRefresh = useCallback(() => {
    if (onCalendarRefresh) {
      onCalendarRefresh();
    } else {
      console.warn("No refresh function registered!");
    }
  }, [onCalendarRefresh]);

  const setOnCalendarRefreshFunction = useCallback((fn) => {
    setOnCalendarRefresh(() => fn);
  }, []);

  const setOnSlotRefreshFunction = useCallback((fn) => {
    setOnSlotRefresh(() => fn);
  }, []);

  const setOnSessionRefreshFunction = useCallback((fn) => {
    setOnSessionRefresh(() => fn);
  }, []);

  return (
    <RefreshContext.Provider
      value={{
        onCalendarRefresh: handleCalendarRefresh,
        onSessionRefresh: handleSessionRefresh,
        onSlotRefresh: handleSlotRefresh,
        setOnSessionRefresh: setOnSessionRefreshFunction,
        setOnSlotRefresh: setOnSlotRefreshFunction,
        setOnCalendarRefresh: setOnCalendarRefreshFunction,
      }}
    >
      {children}
    </RefreshContext.Provider>
  );
};

export const useRefresh = () => {
  const context = useContext(RefreshContext);
  if (!context) {
    throw new Error("useRefresh must be used within a RefreshProvider");
  }
  return context;
};
